import { createStandaloneToast } from '@chakra-ui/react'

const { toast, ToastContainer } = createStandaloneToast()

export { toast, ToastContainer }
